import { useTranslation } from 'react-i18next';
import React, { useRef, useState } from 'react';
import { languageMap } from '../../languageMap';
import i18next from 'i18next';
import { ChevronDownIcon, GlobeAsiaAustraliaIcon } from '@heroicons/react/24/solid';
import { useClickAway } from 'react-use';

export const LanguageSelect = () => {
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const menuRef = useRef(null);

  useClickAway(menuRef, () => setShowLanguageDropdown(false));

  const i18nextLng_item = localStorage.getItem('i18nextLng');
  let selected;
  if (i18nextLng_item) {
    selected = localStorage.getItem('i18nextLng').substring(0, 2);
  } else {
    selected = 'en';
  }

  const { t } = useTranslation();

  const [menuAnchor, setMenuAnchor] = React.useState(null);
  React.useEffect(() => {
    const language = languageMap.get(selected) || languageMap.get('en');
    document.body.dir = language.dir;
  }, [menuAnchor, selected]);

  return (
    <div ref={menuRef} className={'relative cursor-pointer'}>
      <div
        data-testid='language-select-dropdown-button'
        onClick={() => {
          setShowLanguageDropdown((prev) => !prev);
        }}
        className={'flex items-center gap-x-2'}
      >
        <span>
          <GlobeAsiaAustraliaIcon className={'size-10 fill-gray-600'} />
        </span>
        <ChevronDownIcon className={'size-6'} />
      </div>

      <div
        className={`absolute top-12 right-3 z-10 origin-top-right rounded-md bg-white transition-all duration-300 ease-in-out ${showLanguageDropdown ? 'opacity-100' : 'pointer-events-none scale-80 opacity-0'} shadow-lg`}
      >
        <div className={'relative w-58'}>
          {Array.from(languageMap).map((entry, i) => {
            const [lang, props] = entry;
            return (
              <div
                data-testid='language-select-dropdown-item'
                key={`${lang}-${i}`}
                onClick={async () => {
                  await i18next.changeLanguage(lang);
                  setMenuAnchor(null);
                  setShowLanguageDropdown(false);
                }}
                className={
                  'hover:bg-pdteal/5 flex cursor-pointer! items-center gap-x-2 border-b border-gray-200 px-4 py-2'
                }
              >
                <div className={`${selected === lang ? 'font-bold' : ''}`}>{t(props.label)}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
